import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  balanceBillView: string;
  myBillViewState: string;
} = {
  balanceBillView: "",
  myBillViewState: "",
};

const setBalanceBillViewState = (state = initialState, action) => {
  return updateObject(state, { balanceBillView: action.balanceBillView });
};
const setMyBillViewState = (state = initialState, action) => {
  return updateObject(state, { myBillView: action.myBillView });
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_BALANCE_BILL_VIEW_STATE:
      return setBalanceBillViewState(state, action);
    case actionTypes.RESET_BALANCE_BILL_VIEW_STATE:
      return initialState;
    case actionTypes.SET_MY_BILL_VIEW_STATE:
      return setMyBillViewState(state, action);
    case actionTypes.RESET_MY_BILL_VIEW_STATE:
      return initialState;
    default:
      return state;
  }
};
export default reducer;
